const API_BASE_URL = "https://api.gowrisankaragencies.com/";

export default API_BASE_URL;

// https://api.gowrisankaragencies.com/
// http://127.0.0.1:8000/